import { IsNotEmpty, IsPhoneNumber, IsEmail, IsByteLength, NotEquals } from 'class-validator';
import { FormDataBase } from '@/common/form';

export class RegistrationDetailsFormDataNewCloudAccount extends FormDataBase {
    @IsNotEmpty({ message: 'Company Name is required' })
    companyName: string = '';

    @IsNotEmpty({ message: 'Address line 1 is required' })
    companyAddressLine1: string = '';

    companyAddressLine2: string = '';

    @IsNotEmpty({ message: 'City is required' })
    companyAddressCity: string = '';

    @IsNotEmpty({ message: 'Postcode is required' })
    companyAddressPostCode: string = '';

    @IsNotEmpty({ message: 'State/ Province is required' })
    companyAddressState: string = '';

    @IsNotEmpty({ message: 'Country is required' })
    companyAddressCountryCode: string = 'au';

    @IsNotEmpty({ message: 'First Name is required' })
    administrativeContactFirstName: string = '';

    @IsNotEmpty({ message: 'Last Name is required' })
    administrativeContactLastName: string = '';

    @IsPhoneNumber('AU', { message: 'Phone Number is not valid' })
    @IsNotEmpty({ message: 'Phone Number is required' })
    administrativeContactPhone: string = '';

    @IsEmail(undefined, { message: 'Email is not valid' })
    @IsNotEmpty({ message: 'Email is required' })
    administrativeContactEmail: string = '';

    @IsByteLength(1, 10, { message: 'Billing Account Number is not valid' })
    @NotEquals('999999999', { message: 'Billing Account Number is not valid' })
    @NotEquals('9999999999', { message: 'Billing Account Number is not valid' })
    @IsNotEmpty({ message: 'Billing Account Number is required' })
    billingAccountNumber: string = '';

    @IsByteLength(1, 10, { message: 'Customer Identification Number is not valid' })
    @NotEquals('0000000000', { message: 'Customer Identification Number is not valid' })
    @IsNotEmpty({ message: 'Customer Identification Number is required' })
    customerIdentificationNumber: string = '';
}
